import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { DarkTooltip } from "@components/DarkTooltip";
import { buildSalesMetrics } from "./metrics";
import { type PublishRecord } from "./types";

export interface SalesMetricsRowProps {
  item: PublishRecord;
}

export const SalesMetricsRow = (props: SalesMetricsRowProps) => {
  const { item } = props;
  const { t } = useTranslation();
  const metrics = buildSalesMetrics(item.performance, t);

  return (
    <div className="flex w-full items-center gap-[8px]">
      <div className="size-[32px] shrink-0 overflow-hidden rounded-[4px] border border-kds-border bg-kds-bg-element">
        {item.productImage ? <img className="size-full object-cover" src={item.productImage} alt="" /> : null}
      </div>

      <div className="flex min-w-0 flex-col gap-[2px]">
        <DarkTooltip title={item.productTitle || "--"}>
          <p className="truncate text-[12px] font-normal leading-[16px] text-kds-fg-soft">
            {item.productTitle || "--"}
          </p>
        </DarkTooltip>

        <div className="flex flex-wrap items-center gap-x-[8px] gap-y-[4px] text-[14px] font-normal leading-[20px]">
          {metrics.map((metric, index) => (
            <Fragment key={metric.key}>
              {index > 0 ? <span className="h-[16px] w-px shrink-0 bg-kds-border" /> : null}
              <span className="flex items-center gap-[4px] whitespace-nowrap">
                <span className="text-kds-fg-soft">{metric.label}</span>
                <span className="text-kds-fg">{metric.value}</span>
              </span>
            </Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};
